// extracted by mini-css-extract-plugin
export default {"table":"Leads_table__hnJlo","row":"Leads_row__ybpNS"};